import { BasePreset, BehaviorPreset, MarkdownBlocksPreset, MarkdownMarksPreset, YfmPreset, } from '../extensions';
import { EditorModeKeymap } from '../extensions/behavior/EditorModeKeymap';
import { BaseNode, YfmHeadingAttr, YfmNoteNode } from '../extensions/specs';
import { i18n as i18nPlaceholder } from '../i18n/placeholder';
import { Action as A, formatter as f } from '../shortcuts';
import { wCommandMenuConfig, wSelectionMenuConfig } from './config/wysiwyg';
import { emojiDefs } from './emoji';
export const BundlePreset = (builder, opts) => {
    var _a, _b;
    const dropCursor = {
        color: 'var(--g-color-line-brand)',
        width: 2,
    };
    const options = Object.assign(Object.assign({}, opts), { cursor: { dropOptions: dropCursor }, clipboard: Object.assign({ pasteFileHandler: opts.fileUploadHandler }, opts.clipboard), selectionContext: Object.assign({ config: wSelectionMenuConfig }, opts.selectionContext), commandMenu: Object.assign({ actions: wCommandMenuConfig }, opts.commandMenu), baseSchema: Object.assign({ paragraphKey: f.toPM(A.Text), paragraphPlaceholder: (node, parent) => {
                const isDocEmpty = !node.text && (parent === null || parent === void 0 ? void 0 : parent.type.name) === BaseNode.Doc && parent.childCount === 1;
                return isDocEmpty ? i18nPlaceholder('doc_empty') : null;
            } }, opts.baseSchema), breaks: Object.assign({ preferredBreak: (opts.mdBreaks ? 'soft' : 'hard') }, opts.breaks), history: Object.assign({ undoKey: f.toPM(A.Undo), redoKey: f.toPM(A.Redo) }, opts.history), bold: Object.assign({ boldKey: f.toPM(A.Bold) }, opts.bold), italic: Object.assign({ italicKey: f.toPM(A.Italic) }, opts.italic), strike: Object.assign({ strikeKey: f.toPM(A.Strike) }, opts.strike), underline: Object.assign({ underlineKey: f.toPM(A.Underline) }, opts.underline), code: Object.assign({ codeKey: f.toPM(A.Code) }, opts.code), codeBlock: Object.assign({ codeBlockKey: f.toPM(A.CodeBlock) }, opts.codeBlock), blockquote: Object.assign({ qouteKey: f.toPM(A.Quote) }, opts.blockquote), link: Object.assign({ linkKey: f.toPM(A.Link) }, opts.link), lists: Object.assign({ ulKey: f.toPM(A.BulletList), olKey: f.toPM(A.OrderedList), ulInputRules: { plus: false } }, opts.lists), imgSize: Object.assign({ imageUploadHandler: opts.fileUploadHandler, needToSetDimensionsForUploadedImages: opts.needToSetDimensionsForUploadedImages }, opts.imgSize), checkbox: Object.assign({ checkboxLabelPlaceholder: () => i18nPlaceholder('checkbox') }, opts.checkbox), deflist: {
            deflistTermPlaceholder: () => i18nPlaceholder('deflist_term'),
            deflistDescPlaceholder: () => i18nPlaceholder('deflist_desc'),
        }, yfmCut: Object.assign({ yfmCutKey: f.toPM(A.Cut), yfmCutTitlePlaceholder: () => i18nPlaceholder('cut_title'), yfmCutContentPlaceholder: () => i18nPlaceholder('cut_content') }, opts.yfmCut), yfmNote: Object.assign({ yfmNoteKey: f.toPM(A.Note), yfmNoteTitlePlaceholder: () => i18nPlaceholder('note_title') }, opts.yfmNote), yfmTable: Object.assign({ yfmTableCellPlaceholder: () => i18nPlaceholder('table_cell') }, opts.yfmTable), yfmFile: Object.assign({ fileUploadHandler: opts.fileUploadHandler, needToSetDimensionsForUploadedImages: opts.needToSetDimensionsForUploadedImages }, opts.yfmFile), yfmHeading: Object.assign({ h1Key: f.toPM(A.Heading1), h2Key: f.toPM(A.Heading2), h3Key: f.toPM(A.Heading3), h4Key: f.toPM(A.Heading4), h5Key: f.toPM(A.Heading5), h6Key: f.toPM(A.Heading6), headingPlaceholder: (node) => `${i18nPlaceholder('heading')} ${node.attrs[YfmHeadingAttr.Level]}` }, opts.yfmHeading), emoji: Object.assign({ defs: emojiDefs }, opts.emoji), placeholder: {
            [YfmNoteNode.NoteContent]: () => i18nPlaceholder('note_content'),
        } });
    builder
        .use(BehaviorPreset, options)
        .use(BasePreset, options)
        .use(MarkdownMarksPreset, options)
        .use(MarkdownBlocksPreset, Object.assign(Object.assign({}, options), { image: false, heading: false }))
        .use(YfmPreset, options);
    const ignoreActions = [
        A.Undo,
        A.Redo,
        A.Bold,
        A.Italic,
        A.Underline,
        A.Strike,
        A.Code,
        A.Link,
        A.Text,
        A.Heading1,
        A.Heading2,
        A.Heading3,
        A.Heading4,
        A.Heading5,
        A.Heading6,
        A.BulletList,
        A.OrderedList,
        A.Quote,
        A.CodeBlock,
        A.Note,
        A.Cut,
    ];
    const ignoreKeysList = (_b = (_a = opts.ignoreKeysList) === null || _a === void 0 ? void 0 : _a.slice()) !== null && _b !== void 0 ? _b : [];
    for (const action of ignoreActions) {
        const key = f.toPM(action);
        if (key)
            ignoreKeysList.push(key);
    }
    builder.use(EditorModeKeymap, {
        onSubmit: opts.onSubmit,
        onCancel: opts.onCancel,
        ignoreKeysList,
    });
};
